import { Component, OnInit } from '@angular/core';
import { ComunicadosService } from '../comunicados.service';

@Component({
  selector: 'app-mayoristas-comunicados-operaciones',
  templateUrl: './mayoristas-comunicados-operaciones.component.html',
  styleUrls: [
  	'./mayoristas-comunicados-operaciones.component.css',
  	'../../assets/scss/styles.scss',
	'../../assets/scss/general-board.scss', 
    '../../assets/scss/fonts.scss',    
    '../../assets/ema/main.scss',
  	]
})
export class MayoristasComunicadosOperacionesComponent implements OnInit {
  public comunicados;
  constructor(private comunicadosService: ComunicadosService) { }

  ngOnInit() {
    this.comunicadosService.getAllComunicadosbyCategory('Operaciones')
      .then(response => {
        this.comunicados = response;
      })
      .catch(err => console.error(err));
  }

}
